import React from 'react'
import PropertySelector from 'organization/Event/Services/Apps/HubspotV2/Config/PropertySelector'
import {TargetProperty} from 'organization/Event/Services/Apps/HubspotV2/Config'

export default function FieldInput(props: {
  tagsProperty: TargetProperty | null
  onChange: (selected: TargetProperty | null) => void
  errorText?: string
  targetTypes?: TargetProperty['type'][]
}) {
  const {onChange, tagsProperty, errorText, targetTypes} = props

  return (
    <PropertySelector
      value={tagsProperty}
      targetTypes={
        targetTypes ?? [
          'select',
          'text',
          'checkbox',
          'booleancheckbox',
          'radio',
          'phonenumber',
        ]
      }
      onChange={onChange}
      errorText={errorText}
      aria-label="field input"
    />
  )
}
